// src/components/game/PlayerList.js - Kompakt Versiyon
import React from 'react';

export const PlayerList = React.memo(({ 
  gameState, 
  players, 
  myPlayerIndex, 
  playerStats,
  getMaxAttacksForCurrentTurn 
}) => {
  const attackCount = gameState?.attackCount || 0;

  return (
    <div className="glass-panel rounded-xl p-3 h-full flex flex-col border-opacity-20 shadow-xl">
      {/* Header - Daha kompakt */}
      <div className="flex justify-between items-center mb-2 flex-shrink-0 border-b border-slate-700/50 pb-2">
        <h3 className="text-slate-200 text-xs font-bold flex items-center gap-1.5 tracking-wide uppercase">
          <span className="text-sm">👥</span> Oyuncular
        </h3>
        <div className={`text-[10px] font-bold px-2 py-1 rounded-full shadow-sm backdrop-blur-md ${
          attackCount >= getMaxAttacksForCurrentTurn()
            ? 'bg-red-500/20 text-red-300 border border-red-500/30'
            : 'bg-emerald-500/20 text-emerald-300 border border-emerald-500/30'
        }`}>
          ⚔️ {attackCount}/{getMaxAttacksForCurrentTurn()}
        </div>
      </div>

      {/* Player List - Kompakt */}
      <div className="space-y-1.5 flex-1 overflow-y-auto pr-1 custom-scrollbar">
        {players.map((player, index) => {
          const territoryCount = gameState?.grid?.filter(cell => cell === index).length || 0;
          const isCurrentPlayer = index === gameState?.currentPlayerIndex;
          const isEliminated = territoryCount === 0 && gameState?.turn > 0;
          const playerStat = playerStats[index] || { attackPower: 0, defensePower: 0 };

          return (
            <div
              key={player.id || index}
              className={`flex items-center gap-2 p-2 rounded-lg border transition-all duration-200 ${
                isEliminated
                  ? 'opacity-50 bg-red-950/30 border-red-500/20 grayscale'
                  : isCurrentPlayer
                    ? 'bg-blue-600/20 border-blue-400/50 shadow-[0_0_10px_rgba(59,130,246,0.15)] transform scale-[1.01]'
                    : 'bg-slate-800/30 border-slate-700/30 hover:bg-slate-800/50'
              }`}
            >
              {/* Avatar - Küçültüldü */}
              <div className="relative">
                <div
                  className="w-6 h-6 rounded-md shadow-md flex items-center justify-center text-[10px] font-bold text-white border border-white/10"
                  style={{ background: player.color }}
                >
                  {player.name.charAt(0)}
                </div>
                {isCurrentPlayer && (
                  <div className="absolute -bottom-0.5 -right-0.5 w-2 h-2 bg-yellow-400 rounded-full border border-slate-900 animate-pulse"></div>
                )}
              </div>

              {/* Info - Kompakt */}
              <div className="flex-1 min-w-0">
                <div className="flex justify-between items-center">
                  <span className={`font-semibold text-xs truncate ${
                    isCurrentPlayer ? 'text-white' : 'text-slate-300'
                  }`}>
                    {player.name}
                    {index === myPlayerIndex && ' (Sen)'}
                  </span>
                  <span className="text-xs font-bold text-slate-400 bg-slate-950/30 px-1.5 py-0.5 rounded ml-1">
                    {territoryCount}
                  </span>
                </div>
                
                {/* Stats - Tek satır */}
                <div className="flex gap-1.5 text-[9px] font-mono mt-0.5">
                  <span className="text-red-300 bg-red-500/10 px-1 py-0.5 rounded">
                    ATK:{playerStat.attackPower.toFixed(1)}
                  </span>
                  <span className="text-blue-300 bg-blue-500/10 px-1 py-0.5 rounded">
                    DEF:{playerStat.defensePower.toFixed(1)}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});